import { InformationCircleIcon as InfoIcon } from '@heroicons/react/outline';
import { Card } from 'components/Card';
import React from 'react';
import { useTranslation } from 'react-i18next';

const AumGlobal = () => {
  const { t } = useTranslation();
  const dateRefreshed = '20-Aug-2021';
  const totalBalance = '$1,638,274.70';

  return (
    <Card
      title={t('global_stats.total_aum')}
      body={
        <>
          {totalBalance}
          <span className="pl-1 text-xl text-gray-999">USD</span>
        </>
      }
      footer={
        <>
          <a
            href="https://docs.surf.finance/community-locked-liquidity"
            target="_blank"
            rel="noreferrer noopener"
            className={`flex items-center`}
          >
            <InfoIcon className="py-1 mr-2" style={{ flex: '0 0 20px ' }} />
            <span className="uppercase">
              {t('global_stats.data_refresh', { date: dateRefreshed })}
            </span>
          </a>
        </>
      }
      filled
    />
  );
};
export default AumGlobal;
